import "./ShippingInfo.scss";

const ShippingInfo = () => {
  return (
    <div className="shipping-info">
      <p>Free shipping over $50 CAD!</p>
      <p>Within Canada and USA!</p>
    </div>
  );
};
export default ShippingInfo;
